export const DisplaySettingsSkeleton = () => {
  return (
    <div className="flex w-full flex-col gap-4 py-6">
      <div className="h-80 w-full animate-pulse rounded-lg bg-skeleton" />
      <div className="h-36 w-full animate-pulse rounded-lg bg-skeleton" />
      <div className="h-36 w-full animate-pulse rounded-lg bg-skeleton" />
    </div>
  )
}
